// extracted by mini-css-extract-plugin
module.exports = {"exam_analysis_left_viewer_wrapper":"LeftViewer_exam_analysis_left_viewer_wrapper__6Afts"};